import type { CartOrderOption } from 'domains/cart_order_options';
import type { PaymentType } from 'domains/cart_payment_method';
import type { CartShippingMethod, CartPickupMethod } from 'domains/cart_shipping';
import type { LoadingStatus, StrictUnion } from 'types/common_types';

export type CartSliceInitialState = {
  status: LoadingStatus;
  betterCart: Cart | null;
  cartCheck: boolean;
};

export type Cart = {
  guid: string;
  id: number;
  snapshot_id: number;
  on_latest_snapshot: boolean;
  customer_id?: string;
  customer_email?: string;
  color_correct: boolean;
  reference?: string;
  promo_code: string | null;
  created_at: string;
  updated_at: string;
  shipping: StrictUnion<CartShippingMethod | CartPickupMethod> | null;
  payment: CartPayment | null;
  gift_certificate: CartGiftCertificate;
  product_ids: number[];
  addon_ids: number[];
  options: CartOrderOption[];
  project: boolean;
  cart_project_id: number | null;
};

export type CartPayment = {
  last_four?: string;
  postal_code?: string;
  expiration_month?: string;
  expiration_year?: string;
  payment_type: PaymentType;
};

export type CartGiftCertificate = {
  id?: string;
  amount_used?: number;
};

export type CartMigrationDetail = {
  removed_cart_product_ids: number[];
  removed_cart_order_option_ids: number[];
  removed_cart_shipping_method_id: number;
};
